import tw from "twin.macro"
import styled from "@emotion/styled/macro"

import { StyledContainer } from "../../Styled/Container"
import { StyledRow } from "../../Styled/Row"
import { StyledColumn } from "../../Styled/Column"
import { H1, H4, H6, P } from "../../Styled/Text"

export const Section = tw.section`relative bg-teal-sky pb-16 pt-6 overflow-hidden`
export const Container = tw(StyledContainer)`relative`
export const Curve = tw.div`absolute bg-white pointer-events-none w-double h-double rounded-full right-0 bottom-50`
export const Title = tw(H1)`font-normal mb-10 md:mb-0 md:w-152.5 md:text-3xl max-w-full leading-snug-normal max-w-full md:pr-16`
export const Subtitle = tw(P)`md:max-w-141.5`
export const SavedDays = tw.div`max-w-full lg:px-16`
export const Graphs = tw(StyledRow)`mb-12 md:my-16`
export const Graph = tw.div`relative flex flex-col items-center justify-center my-4 md:my-0 w-60 md:w-72.5 max-w-full`
export const Days = styled(H1)`
  ${tw`mt-3.5 md:mt-0 md:mb-2 text-5xl md:mx-5 md:text-6xl`}
  ${({ screen }) => (screen === `sm` ? tw`block md:hidden` : tw`hidden md:block`)}
`
export const Additional = styled(P)`
  ${tw`mt-4 ml-4 md:mt-0 md:ml-0 w-11/20 font-bold max-w-full max-w-40 md:max-w-40.5 leading-snuger-normal`}
  ${({ screen }) => (screen === `sm` ? tw`block md:hidden` : tw`hidden md:block`)}
`
export const Svg = tw.svg`sr-only`
export const Footnote = tw(StyledRow)`hidden md:flex md:w-1/2 max-w-full mt-12.5`
export const Packages = tw(StyledRow)`hidden md:flex`
export const Package = tw(StyledColumn)`mb-12 last:mb-0 md:mb-0 md:mt-12`
export const PackageBubble = tw.div`bg-teal text-white py-4.5 px-3.5 rounded flex items-center justify-start`
export const PackageSave = tw(P)`font-normal`
export const PackageSavings = tw(H4)`ml-2.5`
export const PackageSavingsSup = tw.sup`text-base ml-0.5`
export const IconCircle = tw.div`bg-white rounded-full flex items-center justify-center p-2 text-teal`
export const Label = styled(H6)`
  ${tw`absolute pb-40 md:pb-48 max-w-full w-15 text-center transform transition duration-300 delay-500 opacity-0 translate-y-4`}
  ${({ large }) => large && tw`normal-case tracking-normal leading-tight pb-0 md:pb-0 pt-16 text-base md:text-xl w-2/3 -translate-y-4`}
  ${({ comparison }) => comparison && tw`relative normal-case tracking-normal leading-tight pb-0 text-2xl md:pb-0 md:text-4xl w-2/3 translate-y-0`}
  ${({ visible }) => visible && tw`translate-y-0 opacity-100`}
`
